webpackJsonp([1],[
/* 0 */,
/* 1 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_sass_main_sass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_sass_main_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_sass_main_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);



__WEBPACK_IMPORTED_MODULE_2_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.contacts-button').click(function () {
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#contact-modal').fadeIn();
    document.body.classList.add('body_clipped');
  });
  __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.modal__close').click(function () {
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).parents('.modal').fadeOut();
    document.body.classList.remove('body_clipped');
  });
  __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#feedback-modal').submit(function (e) {
    e.preventDefault();
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#contact-form-submit').addClass('button_loading');
    var form = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this);
    var actionUrl = form.attr('action');
    var data = {
      name: __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#contact-form__name').val(),
      about: __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#contact-form__about').val(),
      email: __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#contact-form__email').val(),
      number: __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#contact-form__number').val(),
      attachments: []
    };
    window.grecaptcha.ready(function () {
      window.grecaptcha.execute('6LerLy8nAAAAAN0vedQRA4S9F9fd852TIY0Lk2Oh', { action: 'submit' }).then(function (token) {
        data.token = token;
        fetch(actionUrl, {
          method: 'POST',
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json'
          },
          body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)
        }).then(function (response) {
          if (response.status !== 200) {
            throw new Error(response);
          }
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#contact-form-submit').removeClass('button_loading');
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#contact-form-submit').addClass('button_sent');
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#contact-form-submit').html('Done');
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#contact-form__name').val('');
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#contact-form__about').val('');
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#contact-form__email').val('');
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#contact-form__number').val('');
          setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#contact-form-submit').removeClass('button_sent');
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#contact-form-submit').html('Submit');
          }, 2000);
          return response;
        }).catch(function () {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#contact-form-submit').removeClass('button_loading');
        });
      });
    });
  });
  __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#nav__menu-button').click(function () {
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#nav').toggleClass('nav_active');
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body').toggleClass('body_clipped');
  });
  __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#main-page-get-in-touch-button').click(function () {
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('html, body').animate({
      scrollTop: __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#main-page-get-in-touch').offset().top
    }, 1000);
  });
});

/***/ })
],[3]);


// WEBPACK FOOTER //
// static/js/app.7fb788ee58b664cf33e9.js